import { useFormikContext } from 'formik'

import { DocumentAccessField } from '../../../DocumentAccessField'
import {
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS,
} from '../../DocumentFolderForm.constants'

import { ACCESS_FIELD_NAMES } from './AccessField.constants'

function AccessField() {
  const { setFieldValue, values } = useFormikContext()

  function handleChangeDwellerAccess(nextValue) {
    if (nextValue) {
      setFieldValue(DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS, {
        ...values[DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS],
        [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_MANAGER]: true,
      })
    }
  }

  function handleChangeManagerAccess(nextValue) {
    if (!nextValue) {
      setFieldValue(DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS, {
        ...values[DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS],
        [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_LANDLORDS]: false,
        [DOCUMENT_FOLDER_FORM_FIELD_NAME_ACCESS_TENANTS]: false,
      })
    }
  }

  return (
    <DocumentAccessField
      name={ACCESS_FIELD_NAMES}
      onChangeDwellerAccess={handleChangeDwellerAccess}
      onChangeManagerAccess={handleChangeManagerAccess}
    />
  )
}

export default AccessField
